import React, { useState, useRef } from 'react'
import { localestr, isNumeric } from '../utils'
import icon from '../icons.svg';
import EditDate from './EditDate';
import TablesTab from './tablesTab';
//import EditDateTime from './EditDateTime';
//import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from "@react-google-maps/api";

let findDlg = false
let keyPres2 = false

function BanquetInput({ setModal, googleMapsApiKey, data, discounts, action, cities, tables }) {
  const [errorMessage, setErrorMessage] = useState(false);
  const [phone, set_phone] = useState(data.phone || '')
  const [address, setaddress] = useState(data.address || '');
  const [booking, setBooking] = useState(data.time_spent || '')
  const [name, setname] = useState(data.name || '');
  const [guests, setGuests] = useState(data.guests);
  const [coment, setComent] = useState(data.coment || '')
  const [finishTo, setFinishTo] = useState(data.finish_to ?? new Date());
  const [time, setTime] = useState(data.time ?? '');
  const [option, setopt] = useState(0)
  const [cnt, setCnt] = useState(0)
  const [hall, setHall] = useState(tables.hall)
  const [table, setTable] = useState(null)
  const [hallModal, setHallModal] = useState(false);
  const [type, setType] = useState(3);
  const [pickup, setpickup] = useState(data.pickup ? 1 : 2)
  const targetRef = useRef()

  let curr_city = null
  let curr_streets = null
  let importAddress = null
  const [city, set_city] = useState(importAddress ? importAddress[0] : curr_city)
  const [streets, set_streets] = useState(curr_streets)
  const [street, set_street] = useState(importAddress ? importAddress[1] : null)
  const [area, set_area] = useState(null)
  const [number, set_number] = useState(importAddress ? importAddress[2] : null)
  const [findArr, setArr] = useState(null);
  const [timer, setTimer] = useState(null);
  const [timerCheckAddress, setTimerCheckAddress] = useState(null);
  //eslint-disable-next-line no-unused-vars
  const [delivCoords, setDelivCoords] = useState({})

  let elem0 = null, elem1 = null, elem2 = null, elem4 = null, elem5 = null, elem6 = null, elem7 = null, elem8 = null, elem9 = null, elem10 = null, elem11 = null, elem12 = null;

  function setphone(d) {
    if (d.length > 0 && !isNumeric(d)) return
    if (d.length > 10) return
    set_phone(d)
    if (d.length === 10) {
      const dsc = discounts.find(el => el.phone && el.phone.startsWith(d))
      // const importAddress = dsc.address.split(', ')
      if (!dsc) return
      if (!name) setname(dsc.name)
    }
  }

  function setcity(val) {
    findDlg = false
    if (val.length > 1) {
      let Arr = cities.filter(el => (el.city || '').toLowerCase().indexOf(val.toLowerCase()) !== -1)
      if (Arr.length > 10) Arr.splice(10)
      if (Arr.length) {
        findDlg = true
        setArr(Arr)
        if (timer) clearTimeout(timer)
        setTimer(setTimeout(() => findDlg = false, 30000))
      }
      else {
        setArr(null)
        findDlg = false
        setTimer(null)
      }
    }
    set_city(val)
    let adr = ''
    if (val) adr = val
    if (street) adr += ', ' + street.trim()
    if (number) adr += ', ' + number.trim()
    if (area) adr += ' (' + area + ')'
    setaddress(adr)

    if (timerCheckAddress) clearTimeout(timerCheckAddress)
    setTimerCheckAddress(setTimeout(() => setDelivCoords(checkAddress(adr)), 1500))
  }

  function setstreet(val) {
    findDlg = false
    if (val.length > 1 && streets) {
      let Arr = streets.filter(el => (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1)
      if (Arr.length > 10) Arr.splice(10)
      if (Arr.length) {
        findDlg = true
        setArr(Arr)
        if (timer) clearTimeout(timer)
        setTimer(setTimeout(() => findDlg = false, 30000))
      }
      else {
        setArr(null)
        findDlg = false
        setTimer(null)
      }
    }
    set_street(val)
    let adr = ''
    if (city) adr = city.trim()
    if (val) adr += ', ' + val
    if (number) adr += ', ' + number.trim()
    if (area) adr += ' (' + area + ')'
    setaddress(adr)

    if (timerCheckAddress) clearTimeout(timerCheckAddress)
    setTimerCheckAddress(setTimeout(() => setDelivCoords(checkAddress(adr)), 1500))
  }

  function setnumber(val) {
    set_number(val)
    let adr = ''
    if (city) adr = city.trim()
    if (street) adr += ', ' + street.trim()
    if (val) adr += ', ' + val
    if (area) adr += ' (' + area + ')'

    setaddress(adr)
    if (timerCheckAddress) clearTimeout(timerCheckAddress)
    setTimerCheckAddress(setTimeout(() => setDelivCoords(checkAddress(adr)), 1500))
  }

  function findClick1(el) {
    findDlg = false
    set_streets(el.streets)
    set_city(el.city)
    setopt(5)
    let adr = ''
    if (el.city) adr = el.city.trim()
    if (street) adr += ', ' + street.trim()
    if (number) adr += ', ' + number.trim()
    if (area) adr += ' (' + area + ')'
    setaddress(adr)
    const el_ = document.getElementById('id7')
    if (el_) setTimeout(() => el_.focus(), 100)
  }

  function findClick2(el) {
    findDlg = false
    set_street(el.name)
    setopt(6)
    let adr = ''
    if (city) adr = city.trim()
    if (el.name) adr += ', ' + el.name
    if (number) adr += ', ' + number.trim()
    if (el.area) adr += ' (' + el.area + ')'
    setaddress(adr)
    set_area(el.area)
    const el_ = document.getElementById('id8')
    if (el_) setTimeout(() => el_.focus(), 100)
  }

  function addNumb(key) {
    let val = ''
    let pos = -1
    let el = null
    if (option === 0) {
      val = phone
      el = elem0
      if (elem0) pos = elem0.selectionStart
    }
    else if (option === 1) {
      // val = address
      el = elem1
      if (elem1) pos = elem1.selectionStart
    }
    else if (option === 2) {
      val = name
      el = elem2
      if (elem2) pos = elem2.selectionStart
    }
    else if (option === 4) {
      // val = city || ''
      el = elem4
      if (elem4) pos = elem4.selectionStart
    }
    else if (option === 5) {
      // val = street || ''
      el = elem5
      if (elem5) pos = elem5.selectionStart
    }
    else if (option === 6) {
      // val = number || ''
      el = elem6
      if (elem6) pos = elem6.selectionStart
    }
    else if (option === 7) {
      val = finishTo || ''
      el = elem7
      if (elem7) pos = elem7.selectionStart
    }
    else if (option === 8) {
      val = finishTo || ''
      el = elem8
      if (elem8) pos = elem8.selectionStart
    }
    else if (option === 9) {
      val = coment || ''
      el = elem9
      if (elem9) pos = elem9.selectionStart
    }
    else if (option === 10) {
      val = guests || ''
      el = elem10
      if (elem10) pos = elem10.selectionStart
    }
    else if (option === 11) {
      val = booking || ''
      el = elem11
      if (elem11) pos = elem11.selectionStart
    }
    else if (option === 12) {
      val = finishTo || ''
      el = elem12
      if (elem12) pos = elem12.selectionStart
    }
    if (!pos) pos = -1
    if (key === -2) { val = ''; pos = -1 }
    else if (key === -1 && val.length && pos === -1) val = val.substring(0, val.length - 1) || 0
    else if (key === -1 && val.length && pos > 0) { val = val.substring(0, pos - 1) + val.substring(pos, val.length); pos-- }
    else if (key !== -1) {
      if (pos === -1) val += '' + key
      else { val = val.substring(0, pos) + key + val.substring(pos, val.length); pos++ }
    }
    if (option === 0) setphone(val)
    // else if (option === 1) setaddress(val)
    else if (option === 2) setname(val)
    else if (option === 3) setComent(val)
    else if (option === 7) setFinishTo(val)
    else if (option === 8) setTime(val)
    else if (option === 9) setComent(val)
    else if (option === 10) setGuests(val)
    else if (option === 11) setBooking(val)
    else if (option === 11) setFinishTo(val)
    if (el && pos !== -1) setTimeout(() => { el.selectionStart = pos; el.selectionEnd = pos }, 10)
    //keyPres2 = true
    //setTimeout(() => { keyPres2 = false }, 400)
  }

  let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

  function dragMouseDown(e) {
    e = e || window.event;
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    const elmnt = document.getElementById('modalWnd')
    e = e || window.event;
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    if (pos2 !== 0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
    if (pos1 !== 0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
  }

  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }

  const checkAddress = async (adr) => {
    if (!adr?.trim()) return null;

    try {

      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(adr)}&key=${googleMapsApiKey}`
      );

      const data = await response.json()
      if (data.status !== "OK" || !data.results.length) {
        throw new Error("Address not found")
      }

      const result = data.results[0]

      if (result.partial_match) {
        throw new Error("Partial match")
      }

      const coords = {
        lat: result.geometry.location.lat,
        lng: result.geometry.location.lng
      };

      setErrorMessage(false)
      return coords
    } catch (e) {
      setErrorMessage(true)
      setDelivCoords({})
    }
  }

  /*let finishText = 'Доставити'

  if (pickup === 1) {
    finishText = 'Приготувати'
  }*/

  async function retValue(tbl = {}) {
    let discount = undefined;
    let updatedFinishTo = finishTo;
    //let dateNow = new Date()
    let bookingMin = 0

    if (booking) {
      const time = booking.split(':')
      bookingMin = (parseInt(time[0]) * 60) + parseInt(time[0])
    }

    if (time && finishTo) {
      const hours = Number(time.slice(0, 2));
      const minutes = Number(time.slice(3));

      const date = new Date(finishTo);
      date.setHours(hours, minutes, 0, 0);

      updatedFinishTo = date;

      setFinishTo(date);
    }

    if (Date.now() < new Date(updatedFinishTo).getTime()) {
      if (discounts && phone.length > 9) discount = discounts.find(el => el.phone && el.phone.startsWith(phone))
      if (pickup === 1) {
        action({ phone, address, guests, time_spent: bookingMin, docType: type, name, finish_to: updatedFinishTo, coment, discount, ...table, pickup: true })
      } else {
        action({ phone, name, guests, docType: type, time_spent: bookingMin, finish_to: updatedFinishTo, coment, discount, ...table, pickup: false })
      }
    } else {
      setErrorMessage('Дата замовлення не може бути раніше створення')
      return
    }

    setModal('')
  }

  function keyClick(e) {
    if (e.key === 'Enter') {
      if (option === 0) setopt(1)
      else if (option === 1) setopt(2)
      else if (option === 4) setopt(5)
      else if (option === 5) setopt(6)
      else retValue()
    }
    else if (e.key === 'Escape') setModal('')
  }

  function getSymbol(ind) {
    const str = localestr('йцукенгшщзхїфівапролджєячсмитьбюЙЦУКЕНГШЩЗХЇФІВАПРОЛДЖЄЯЧСМИТЬБЮ')
    if (cnt === 2) return str[ind + 32]
    return str[ind]
  }

  function setFocus(el, opt = 0) {
    if (!el) return
    if (opt === 0) elem0 = el
    if (opt === 1) elem1 = el
    if (opt === 2) elem2 = el
    if (opt === 4) elem4 = el
    if (opt === 5) elem5 = el
    if (opt === 6) elem6 = el
    if (opt === 7) elem7 = el
    if (opt === 8) elem8 = el
    if (opt === 9) elem9 = el
    if (opt === 10) elem10 = el
    if (opt === 11) elem11 = el
    if (opt === 12) elem12 = el
    if (option !== opt) return
    //if (!isActive) return
    //el.select()
    el.focus()
  }

  function after_focus(opt) {
    if (option === opt) return
    setopt(opt)
  }

  function find_disc() {
    if (phone.length < 10) return
    if (!discounts) return
    const dsc = discounts.find(el => el.phone && el.phone.startsWith(phone))
    if (!dsc) return
    // if (!address) setaddress(dsc.address)
    if (!name) setname(dsc.name)
  }

  let discs = []
  if (phone.length > 5 && discounts) discs = discounts.filter(el => el.phone && el.phone.startsWith(phone))
  if (discs.length > 5) discs = discs.filter((el, idx) => idx < 5)

  const opts = discs.map((el, idx) => <option key={idx} value={el.phone} />)

  const keyStl = { minWidth: '20px', display: 'inline-block', verticalAlign: 'bottom', flexGrow: '1', borderRadius: '6px' }
  const keyStl2 = { height: '32px', lineHeight: '32px', display: 'block' }
  const keyStl2g = { height: '32px', lineHeight: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--dark-btn-color)' }
  const keyStl3 = { margin: '2px -2px 0 ', display: 'flex', justifyContent: 'center' }
  if (window.innerHeight < 350) { keyStl2.height = '23px'; keyStl2.lineHeight = '23px' }
  else if (window.innerHeight < 400) { keyStl2.height = '28px'; keyStl2.lineHeight = '28px' }
  if (window.innerWidth < 400) { keyStl.margin = '1px 0.5px'; keyStl3.margin = '2px -4px 0'; keyStl3.width = (window.innerWidth - 8) + 'px' }

  let findItems1 = null
  if (findDlg && findArr && option === 4) {
    const items = findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small', lineHeight: '28px', textWrap: 'nowrap', display: 'flex', margin: '2px' }
      return (
        <div key={idx} style={stl} onClick={() => { findClick1(el) }}><div style={{ width: '100%', textAlign: 'left', overflow: 'hidden' }}>{el.city}</div></div>
      )
    })
    findItems1 = <div className='no-print' style={{ right: '0px', top: '23px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100', border: '1px solid #0003' }}>
      {items}
    </div>
  }

  let findItems2 = null
  if (findDlg && findArr && option === 5) {
    const items = findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small', lineHeight: '28px', textWrap: 'nowrap', display: 'flex', margin: '2px' }
      return (
        <div key={idx} style={stl} onClick={() => { findClick2(el) }}><div style={{ width: '100%', textAlign: 'left', overflow: 'hidden' }}>{el.name}</div></div>
      )
    })
    findItems2 = <div className='no-print' style={{ right: '0px', top: '23px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100', border: '1px solid #0003' }}>
      {items}
    </div>
  }

  return (
    <div className='modal'><div id='modalWnd' className='window'>
      <div onMouseDown={dragMouseDown} style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}><div className='caption'>{localestr('Попереднє замовлення')}</div><div className='closebtn' onClick={() => { setModal('') }} /></div>
      <div className='content'>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', columnGap: '20px', rowGap: '10px', flexWrap: 'wrap' }}>
          <label><input id={'inner'} type='radio' name={'deliv'} value={2} checked={pickup === 2} onChange={(e) => { setpickup(parseInt(e.target.value)); setType(0) }} /> {localestr('В закладі')} </label>
          <label><input id={'deliv'} type='radio' name={'deliv'} value={1} checked={pickup === 1} onChange={(e) => { setpickup(parseInt(e.target.value)); setType(1) }} /> {localestr('Доставка')} </label>
          <label><input id={'pick'} type='radio' name={'deliv'} value={3} checked={pickup === 3} onChange={(e) => { setpickup(parseInt(e.target.value)); setType(2) }} /> {localestr('Самовивіз')} </label>
        </div>
        {pickup === 2 ? (
          <div>
            <div style={{ display: 'inline-flex', justifyContent: 'center', width: '100%', gap: '10px' }}>
              <div onKeyUp={keyClick} onBlur={find_disc} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px' }} htmlFor="id3">
                  <div style={{ display: 'inline-flex', minWidth: '70px', lineHeight: '24px', flexBasis: '70px', flexGrow: 35 }}>{localestr('Телефон')} </div>
                  <input list='phones' onFocus={() => after_focus(0)} ref={el => { setFocus(el, 0); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '110px', boxSizing: 'border-box', height: '24px', flexBasis: '110px', flexGrow: 110 }} id="id3" type="text" value={phone || ''} onChange={e => setphone(e.target.value)} />
                  <datalist id='phones'>{opts}</datalist>
                </label>
              </div>

              <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px' }} htmlFor="id5">
                  <div style={{ display: 'inline-flex', minWidth: '40px', lineHeight: '24px', flexBasis: '40px', flexGrow: 20 }}>{localestr('Ім\'я')} </div>
                  <input onFocus={() => after_focus(2)} ref={el => { setFocus(el, 2); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '90px', boxSizing: 'border-box', height: '24px', flexBasis: '120px', flexGrow: 120 }} id="id5" type="text" value={name || ''} onChange={e => setname(e.target.value)} />
                </label>
              </div>
            </div>

            <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'inline-flex', minWidth: '110px', lineHeight: '24px', flexBasis: '40px', flexGrow: 0 }}>
                <label htmlFor="id9">
                  {localestr("Дата початку")}
                </label>
              </div>
              <div style={{ display: 'inline-flex', minWidth: '130px', lineHeight: '24px', flexBasis: '120px', flexGrow: 0 }}><EditDate Value={finishTo} setVal={setFinishTo} /></div>
              <div style={{ display: 'inline-flex', minWidth: '20px', lineHeight: '24px', flexBasis: '20px', flexGrow: 0 }}><label htmlFor="id10">{localestr('на')}</label></div>
              <input type='time' onFocus={() => after_focus(8)} ref={el => { setFocus(el, 8); return targetRef }} autoComplete="off" id="id10" placeholder='40'
                style={{ display: 'inline-flex', boxSizing: 'border-box', height: '25px', width: '75px', flexBasis: '75px' }}
                value={time || ''} onChange={e => setTime(e.target.value)} />
              <div style={{ display: 'inline-flex', minWidth: '25px', lineHeight: '24px', flexBasis: '25px', flexGrow: 0 }}>{localestr('год')}</div>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '100%', gap: '10px', alignItems: 'center', margin: '2px 0 0 0' }}>
              <label style={{ display: 'inline-flex' }} htmlFor="id6">
                <div style={{ display: 'inline-flex', minWidth: '130px', lineHeight: '24px', flexBasis: '40px', flexGrow: 20 }}>{localestr('Кількість персон')} </div>
                <input onFocus={() => after_focus(10)} ref={el => { setFocus(el, 10); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '55px', boxSizing: 'border-box', height: '24px', flexBasis: '120px', flexGrow: 120 }} id="id6" type="text" value={guests || ''} onChange={e => setGuests(e.target.value)} />
              </label>

              <label style={{ display: 'inline-flex', }} htmlFor="id6">
                <div style={{ display: 'inline-flex', minWidth: '120px', lineHeight: '24px', flexBasis: '40px', flexGrow: 20 }}>
                  {localestr('Тривалість год')}
                </div>
                <input type='time' onFocus={() => after_focus(11)} ref={el => { setFocus(el, 11); return targetRef }} autoComplete="off" id="id13" placeholder='40'
                  style={{ display: 'inline-flex', boxSizing: 'border-box', height: '25px', flexBasis: '90px' }}
                  value={booking || ''} onChange={e => setBooking(e.target.value)} />
              </label>

              <label style={{ display: 'flex', gap: '15px' }} htmlFor="id11">
                {table?.table?.name ? (
                  <div>
                    <i style={{ display: 'flex', gap: '10' }}>
                      <div style={{ display: 'inline-flex', minWidth: '57px', lineHeight: '24px', flexBasis: '20px', flexGrow: 20 }}>
                        {localestr('Зал ')} <b>{tables.hall}</b>
                      </div>
                      <div style={{ display: 'inline-flex', minWidth: '55px', lineHeight: '24px', flexBasis: '20px', flexGrow: 20 }}>
                        <i>{localestr('Стіл')} <b>{table?.table?.name}</b></i>
                      </div>
                    </i>
                  </div>
                ) : (
                  <div style={{ display: 'inline-flex', minWidth: '30px', lineHeight: '24px', flexBasis: '20px', flexGrow: 20 }}>
                    <i>
                      {localestr('Стіл не вибрано')}
                    </i>
                  </div>
                )}
                <button
                  className={'key_btn'}
                  style={{ width: '120px', display: 'inline-block', backgroundColor: '#fff', height: '24px' }}
                  onClick={() => setHallModal(true)}
                >
                  Вибрати стіл
                </button>
              </label>
            </div>

            <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
              {hallModal && (
                <div className='modal'>
                  <div id='modalWnd' className='window'>
                    <div onMouseDown={dragMouseDown} style={{ flexDirection: 'row', display: 'flex', justifyContent: 'flex-start' }}>
                      <div className='caption'>{localestr('Вибрати стіл')}</div><div className='closebtn' onClick={() => { setHallModal(false) }} />
                    </div>
                    <div className='content'>
                      <div className='content' style={{ width: '350px', height: '350px' }}>
                        <TablesTab
                          userId={tables.user_id}
                          hall={hall}
                          setHall={setHall}
                          tblClick={(tbl) => {
                            setTable(tbl)
                            setHallModal(false);
                          }}
                          Data={tables.catHalls}
                          Orders={tables.orders}
                          Rights={tables.rights}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
              <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px' }} htmlFor="id7">
                <div style={{ display: 'inline-flex', minWidth: '80px', lineHeight: '24px', flexBasis: '40px', flexGrow: 20 }}>{localestr('Коментар')} </div>
                <input onFocus={() => after_focus(9)} ref={el => { setFocus(el, 9); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '120px', boxSizing: 'border-box', height: '24px', flexBasis: '120px', flexGrow: 120 }} id="id7" type="text" value={coment || ''} onChange={e => setComent(e.target.value)} />
              </label>
            </div>


          </div>
        ) : (
          <>
            <div style={{ display: 'inline-flex', justifyContent: 'center', width: '100%', gap: '10px' }}>
              <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px' }} htmlFor="id5">
                  <div style={{ display: 'inline-flex', minWidth: '40px', lineHeight: '24px', flexBasis: '40px', flexGrow: 20 }}>{localestr('Ім\'я')} </div>
                  <input onFocus={() => after_focus(2)} ref={el => { setFocus(el, 2); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '90px', boxSizing: 'border-box', height: '24px', flexBasis: '120px', flexGrow: 120 }} id="id5" type="text" value={name || ''} onChange={e => setname(e.target.value)} />
                </label>
              </div>

              <div onKeyUp={keyClick} onBlur={find_disc} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px' }} htmlFor="id3">
                  <div style={{ display: 'inline-flex', minWidth: '70px', lineHeight: '24px', flexBasis: '60px', flexGrow: 30 }}>{localestr('Телефон')} </div>
                  <input list='phones' onFocus={() => after_focus(0)} ref={el => { setFocus(el, 0); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '150px', boxSizing: 'border-box', height: '24px', flexBasis: '120px', flexGrow: 120 }} id="id3" type="text" value={phone || ''} onChange={e => setphone(e.target.value)} />
                  <datalist id='phones'>{opts}</datalist>
                </label>
              </div>
            </div>

            {pickup === 1 && (
              <>
                <div onKeyUp={keyClick} style={{ margin: '5px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                  <label style={{ position: 'relative', display: 'flex', margin: 'inherit', flexGrow: 30, maxWidth: '120px', flexWrap: 'nowrap' }} htmlFor="id6">
                    <div style={{ display: 'inline-flex', minWidth: '15px', lineHeight: '24px', flexBasis: '15px', flexGrow: 0 }}>{localestr('м.')} </div>
                    <input onFocus={() => after_focus(4)} ref={el => { setFocus(el, 4); return targetRef }} autoComplete="off" onChange={e => setcity(e.target.value)} onBlur={() => { setTimeout(() => { if (!keyPres2) setArr(null) }, 200) }}
                      style={{ display: 'inline-flex', width: '70px', boxSizing: 'border-box', height: '24px', flexBasis: '70px', flexGrow: 50 }} id="id6" type="text" value={city || ''} />
                    {findItems1}
                  </label>
                  <label style={{ position: 'relative', display: 'flex', margin: 'inherit', flexGrow: 60, maxWidth: '180px', flexWrap: 'nowrap' }} htmlFor="id7">
                    <div style={{ display: 'inline-flex', minWidth: '29px', lineHeight: '24px', flexBasis: '29px', flexGrow: 0 }}>{localestr('вул.')} </div>
                    <input onFocus={() => after_focus(5)} ref={el => { setFocus(el, 5); return targetRef }} autoComplete="off" onChange={e => setstreet(e.target.value)} onBlur={() => { setTimeout(() => { if (!keyPres2) setArr(null) }, 200) }}
                      style={{ display: 'inline-flex', width: '110px', boxSizing: 'border-box', height: '24px', flexBasis: '110px', flexGrow: 340 }} id="id7" type="text" value={street || ''} />
                    {findItems2}
                  </label>
                  <label style={{ display: 'flex', margin: 'inherit', flexGrow: 30, maxWidth: '120px', flexWrap: 'nowrap' }} htmlFor="id8">
                    <div style={{ display: 'inline-flex', minWidth: '18px', lineHeight: '24px', flexBasis: '18px', flexGrow: 0 }}>{localestr('№')} </div>
                    <input onFocus={() => after_focus(6)} ref={el => { setFocus(el, 6); return targetRef }} autoComplete="off" onChange={e => setnumber(e.target.value)} onBlur={() => { setTimeout(() => setArr(null), 200) }}
                      style={{ display: 'inline-flex', width: '40px', boxSizing: 'border-box', height: '24px', flexBasis: '40px', flexGrow: 340 }} id="id8" type="text" value={number || ''} />
                  </label>
                </div>

                <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
                  <label style={{ display: 'inline-flex', margin: 'inherit', flexGrow: 180, maxWidth: '360px', flexWrap: 'wrap' }} htmlFor="id4">
                    <div style={{ display: 'inline-flex', minWidth: '60px', lineHeight: '24px', flexBasis: '60px', flexGrow: 30 }}>{localestr('Адреса')} </div>
                    <input onFocus={() => after_focus(1)} ref={el => { setFocus(el, 1); return targetRef }} autoComplete="off" style={{ display: 'inline-flex', width: '280px', boxSizing: 'border-box', height: '24px', flexBasis: '340px', flexGrow: 340 }} id="id4" type="text" value={address || ''} onChange={e => setaddress(e.target.value)} />
                  </label>
                </div>
              </>
            )}



            <div onKeyUp={keyClick} style={{ margin: '2px 0 0 0', display: 'flex', justifyContent: 'center' }}>
              <div style={{ display: 'inline-flex', minWidth: '110px', lineHeight: '24px', flexBasis: '40px', flexGrow: 0 }}>
                <label htmlFor="id9">
                  {pickup === 3 && localestr("Приготувати")}
                  {pickup === 1 && localestr("Доставити")}
                  {pickup === 0 && localestr("Дата початку")}
                </label>
              </div>
              <EditDate Value={finishTo} setVal={setFinishTo} />
              <div style={{ display: 'inline-flex', minWidth: '20px', lineHeight: '24px', flexBasis: '20px', flexGrow: 0 }}><label htmlFor="id10">{localestr('на')}</label></div>
              <input type='time' onFocus={() => after_focus(8)} ref={el => { setFocus(el, 8); return targetRef }} autoComplete="off" id="id10" placeholder='40'
                style={{ display: 'inline-flex', boxSizing: 'border-box', height: '25px', flexBasis: '90px' }}
                value={time || ''} onChange={e => setTime(e.target.value)} />
              <div style={{ display: 'inline-flex', minWidth: '4px', lineHeight: '24px', flexBasis: '4px', flexGrow: 0 }}></div>
              <div style={{ display: 'inline-flex', minWidth: '15px', lineHeight: '24px', flexBasis: '15px', flexGrow: 0 }}>{localestr('год')}</div>
            </div>
          </>
        )}

        {errorMessage && (
          <>
            <div style={{ height: '10px' }}></div>
            <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}>
              {errorMessage}
            </div>
          </>
        )}

        <div style={{ height: '10px' }}></div>
        <div style={keyStl3}>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(1) }}><div style={keyStl2}>1</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(2) }}><div style={keyStl2}>2</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(3) }}><div style={keyStl2}>3</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(4) }}><div style={keyStl2}>4</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(5) }}><div style={keyStl2}>5</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(6) }}><div style={keyStl2}>6</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(7) }}><div style={keyStl2}>7</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(8) }}><div style={keyStl2}>8</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(9) }}><div style={keyStl2}>9</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(0) }}><div style={keyStl2}>0</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(-1) }}><div style={keyStl2g}><img style={{ width: '24px', height: '24px' }} src={icon + '#key_b'} alt='' /></div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(-2) }}><div style={keyStl2g}><img style={{ width: '18px', height: '18px' }} src={icon + '#calcx'} alt='' /></div></div>
        </div>
        <div style={keyStl3}>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(0)) }}><div style={keyStl2}>{getSymbol(0)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(1)) }}><div style={keyStl2}>{getSymbol(1)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(2)) }}><div style={keyStl2}>{getSymbol(2)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(3)) }}><div style={keyStl2}>{getSymbol(3)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(4)) }}><div style={keyStl2}>{getSymbol(4)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(5)) }}><div style={keyStl2}>{getSymbol(5)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(6)) }}><div style={keyStl2}>{getSymbol(6)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(7)) }}><div style={keyStl2}>{getSymbol(7)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(8)) }}><div style={keyStl2}>{getSymbol(8)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(9)) }}><div style={keyStl2}>{getSymbol(9)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(10)) }}><div style={keyStl2}>{getSymbol(10)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(11)) }}><div style={keyStl2}>{getSymbol(11)}</div></div>
        </div>
        <div style={keyStl3}>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(12)) }}><div style={keyStl2}>{getSymbol(12)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(13)) }}><div style={keyStl2}>{getSymbol(13)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(14)) }}><div style={keyStl2}>{getSymbol(14)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(15)) }}><div style={keyStl2}>{getSymbol(15)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(16)) }}><div style={keyStl2}>{getSymbol(16)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(17)) }}><div style={keyStl2}>{getSymbol(17)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(18)) }}><div style={keyStl2}>{getSymbol(18)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(19)) }}><div style={keyStl2}>{getSymbol(19)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(20)) }}><div style={keyStl2}>{getSymbol(20)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(21)) }}><div style={keyStl2}>{getSymbol(21)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(22)) }}><div style={keyStl2}>{getSymbol(22)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('\'') }}><div style={keyStl2}>'</div></div>
        </div>
        <div style={keyStl3}>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(23)) }}><div style={keyStl2}>{getSymbol(23)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(24)) }}><div style={keyStl2}>{getSymbol(24)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(25)) }}><div style={keyStl2}>{getSymbol(25)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(26)) }}><div style={keyStl2}>{getSymbol(26)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(27)) }}><div style={keyStl2}>{getSymbol(27)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(28)) }}><div style={keyStl2}>{getSymbol(28)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(29)) }}><div style={keyStl2}>{getSymbol(29)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(30)) }}><div style={keyStl2}>{getSymbol(30)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(getSymbol(31)) }}><div style={keyStl2}>{getSymbol(31)}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(',') }}><div style={keyStl2}>,</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('.') }}><div style={keyStl2}>.</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('/') }}><div style={keyStl2}>/</div></div>
        </div>
        <div style={keyStl3}>
          <div style={keyStl} className={'key_btn'} onClick={() => { setCnt(cnt === 2 ? 1 : 2) }}><div style={keyStl2g}><img style={{ width: '16px', height: '16px' }} src={icon + '#key_s'} alt='' /></div></div>
          <div style={{ ...keyStl, margin: '0 0 0 14px', minWidth: '100px', flexGrow: '1' }} className={'key_btn'} onClick={() => { addNumb(' ') }}><div style={keyStl2}>_______</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('(') }}><div style={keyStl2}>{'('}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb(')') }}><div style={keyStl2}>{')'}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('<') }}><div style={keyStl2}>{'<'}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('>') }}><div style={keyStl2}>{'>'}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('+') }}><div style={keyStl2}>{'+'}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('-') }}><div style={keyStl2}>{'-'}</div></div>
          <div style={keyStl} className={'key_btn'} onClick={() => { addNumb('?') }}><div style={keyStl2}>{'?'}</div></div>
        </div>


        <div style={{ margin: '4px 0 0 0', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '80px', height: '32px', display: 'inline-block', verticalAlign: 'bottom' }} className={'ord_button2 toolBarItem toolBarItem2'} onClick={() => retValue()}><div style={{ height: '30px', lineHeight: '24px', display: 'block' }}>OK</div></div>
          <div style={{ width: '80px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { setModal('') }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Закрити')}</div></div>
        </div></div>
    </div></div >
  )
}


export default BanquetInput